module.exports = __webpack_public_path__ + "img/cm.7e6294f8.svg";